<template>
  <v-container grid-list-xl class="limited">
    <v-layout column>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 md8>
            <v-card class="pa-5" :color="highContrast ? 'dark' : 'primary'">
              <h1 class="display-2 font-weight-black white--text mb-4">
                Olá
                {{ dadosBeneficiario.nome }}!
              </h1>
              <h2 class="headline white--text">
                Bem-vindo ao Portal do Beneficiário.
                <br />Utilize o menu ao lado para navegar.
              </h2>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <beneficiary-data></beneficiary-data>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <modal-confirma-benef-dados-atualizados />
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import BeneficiaryData from "@/components/BeneficiaryData";
import ModalConfirmaBenefDadosAtualizados from "@/components/ModalConfirmaBenefDadosAtualizados";
import {
  getParametro,
  verificarCadastroBeneficiarioDesatualizado
} from "@/services/beneficiario";
import defaultTheme from "../plugins/default-theme";
import unimedTheme from "../plugins/unimed-theme";
import { storage } from "@/plugins";
import { benefTemMovInclusaoAlteracaoAberto } from "@/services/movimentos";

const THEME_PARAM = 15;
const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "Home",
  components: {
    BeneficiaryData,
    ModalConfirmaBenefDadosAtualizados
  },
  async created() {
    var themeDefault = await getParametro(THEME_PARAM);
    storage.setItem("themeDefault", themeDefault);
    if (eval(themeDefault)) {
      this.$vuetify.theme = unimedTheme;
    } else {
      this.$vuetify.theme = defaultTheme;
    }
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    ...portalStore.mapState(["highContrast"])
  },
  data() {
    return {
      updateDataFrequency: null,
      notifications: [
        { text: "Lorem ipsum dolor sit amet, consectetur", date: "10/05" },
        {
          text:
            "Suspendisse tincidunt pellentesque ipsum sit amet faucibus. Nulla dictum",
          date: "10/05"
        },
        { text: "Seus dados foram atualizador com sucesso!", date: "10/05" }
      ]
    };
  },
  async mounted() {
    this.setShowModalConfirmaBenefDadosAtualizados(
      await this.hasToShowUpdateDataModal()
    );
  },
  methods: {
    ...portalStore.mapMutations(["setShowModalConfirmaBenefDadosAtualizados"]),
    async hasToShowUpdateDataModal() {
      const [
        cadastroEstaDesatualizado,
        temMovimentoAlteracaoEmAberto
      ] = await Promise.all([
        this.cadastroBeneficiarioDesatualizado(),
        this.beneficiarioNaoTemMovimentoAlteracaoEmAberto()
      ]);

      return cadastroEstaDesatualizado && temMovimentoAlteracaoEmAberto;
    },
    async beneficiarioNaoTemMovimentoAlteracaoEmAberto() {
      const { id, titularId } = this.dadosBeneficiario;

      return !(await benefTemMovInclusaoAlteracaoAberto(id, titularId));
    },
    async cadastroBeneficiarioDesatualizado() {
      const { id } = this.dadosBeneficiario;
      return await verificarCadastroBeneficiarioDesatualizado(id);
    }
  }
};
</script>
